// Inline-SVG icon set for marker categories. Config files reference these by
// name (see server/default-categories.json). All MIT-licensed, hand-drawn here.

function svg(inner: string): string {
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">${inner}</svg>`;
}

export const ICONS: Record<string, string> = {
  trash: svg('<path d="M5 7h14M9 7V5h6v2M7 7l1 13h8l1-13"/><path d="M10 11v6M14 11v6"/>'),
  ashtray: svg('<ellipse cx="12" cy="14" rx="7" ry="3.2"/><path d="M9 14a3 3 0 106 0"/><path d="M15 8l4-1.5M16.5 10l3 1"/>'),
  bench: svg('<path d="M3 11h18M5 11V8h14v3M5 11v6M19 11v6M7 17v2M17 17v2"/>'),
  barrier: svg('<path d="M4 18V6M20 18V6"/><rect x="4" y="9" width="16" height="3" transform="rotate(-8 12 10.5)"/>'),
  sign: svg('<path d="M6 20V6"/><rect x="6" y="5" width="13" height="8" rx="1"/><path d="M9 9h7"/>'),
  plant: svg('<path d="M8 20h8l-1-6H9z"/><path d="M12 14V9"/><path d="M12 9c-3 0-5-2-5-5 3 0 5 2 5 5zM12 9c3 0 5-2 5-5-3 0-5 2-5 5z"/>'),
  plug: svg('<rect x="5" y="8" width="14" height="9" rx="2"/><path d="M9 8V4M15 8V4M12 17v3"/>'),
  dot: svg('<path d="M12 3l2.4 5.8L20 11l-5.6 2.2L12 19l-2.4-5.8L4 11l5.6-2.2z"/>'),
};

export function iconMarkup(name: string | null | undefined): string {
  return (name && ICONS[name]) || ICONS.dot!;
}
